/**
 * Created by Mark on 23/11/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants/words-learnt.js';
import Actions from '../actions/default.js';


class WordsLearntService {

    constructor(){
        this.isAuthenticated = false;
        this.timeout = null;
    }

    getLineGraphAccountLevel(from ,  to){
        return ApplicationServices.call(Constants.GET_WORDS_LEARNT_ACCOUNT_LEVEL , {from:from , to:to} ).then(function(response){
            Actions.update(Constants.UPDATE_ACCOUNT_LEVEL , response['words_learnt'])
        });
    }

    getTotal(){
        return ApplicationServices.call(Constants.GET_WORDS_TOTAL_ACCOUNT , {} ).then(function(response){
            Actions.update(Constants.UPDATE_ACCOUNT_TOTAL , response['total'])
        });
    }

    getLineGraphClassLevel(class_uid , from ,  to , language){
        return ApplicationServices.call(Constants.GET_WORDS_TOTAL_CLASS , {languageID:language , class_uid:class_uid , from:from , to:to} ).then(function(response){
            Actions.update(Constants.UPDATE_CLASS_TOTAL , response['words_learnt'])
        });
    }

    getLineGraphStudentLevel(class_uid , from ,  to , languageID){

        return ApplicationServices.call(Constants.GET_WORDS_TOTAL_STUDENT , {languageID:languageID , studentID:class_uid , from:from , to:to} ).then(function(response){
            Actions.update(Constants.UPDATE_STUDENT_TOTAL , response['words_learnt'])
        });
    }

    getClassTotal(class_uid , from ,  to , language){
        return ApplicationServices.call(Constants.GET_CLASS_TOTAL , {from:from , to:to , languageID:language , classID:class_uid} ).then(function(response){
            Actions.update(Constants.UPDATE_CLASS_WORDS_TOTAL , response['total'])
        });
    }

    getStudentTotal(studentID , from ,  to , language){

        return ApplicationServices.call(Constants.GET_STUDENT_TOTAL , {from:from , to:to , languageID:language , studentID:studentID} ).then(function(response){
            Actions.update(Constants.UPDATE_STUDENT_WORDS_TOTAL , response['total'])
        });
    }

}


export default new WordsLearntService();


// WEBPACK FOOTER //
// ./src/services/wordslearnt-services.js